<template>
  <div
    class="
      d-flex
      justify-content-center
      align-items-center
      minting-parchment
      w-100
    "
    style="height: 90vh"
  >
    <div class="minting-side">
      <div class="d-flex flex-row justify-content-center">
        <span class="minting-header">MINTING</span>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <span class="minted-information"
          >{{ minted }} / {{ maxTokens }} minted</span
        >
      </div>
      <div class="d-flex flex-row justify-content-center mt-2">
        <div class="d-flex flex-row justify-content-center position-relative">
          <mint-tube :choosenWidth="(minted * 100) / maxTokens"></mint-tube>
          <span v-if="mintingPaused" class="paused-mint-text"
            >Minting paused
          </span>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="mint-button-accelerator">
          <button
            class="minus-button"
            @click="choosedMintingAmount < 2 ? '' : choosedMintingAmount--"
          >
            <img src="../assets/images/minus.webp" alt="" />
          </button>
          <div class="button-seperator">{{ choosedMintingAmount }}</div>
          <button class="plus-button" @click="choosedMintingAmount++">
            <img src="../assets/images/plus.webp" alt="" />
          </button>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <span class="mint-price"
          >price = {{ mintingPriceRepresentation }} $MATIC
        </span>
      </div>
      <div class="mt-3">
        <div
          class="
            mint-and-mint-n-stake-button
            d-flex
            flex-row
            justify-content-center
          "
        >
          <button class="mint-button" @click="mintClicked()">
            <div
              class="d-flex justify-content-center position-relative mr-md-5"
            >
              <img
                class="mint-button-image"
                src="../assets/images/stake-button-bg.webp"
                alt=""
              />
              <span class="mint-button-text">mint</span>
            </div>
          </button>
          <button class="mint-button" @click="mintAndStakeClicked()">
            <div
              class="
                d-flex
                flex-row
                justify-content-center
                position-relative
                ml-md-5
              "
            >
              <img
                class="mint-button-image"
                src="../assets/images/stake-button-bg.webp"
                alt=""
              />
              <span class="mint-button-text">mint n stake </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MintTube from "./MintTube.vue";
export default {
  components: {
    MintTube,
  },
  props: {
    mintingPriceRepresentation: {
      default: "0",
      type: String,
    },
    minted: {
      default: 0,
      type: Number,
    },
    mintingPaused: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      choosedMintingAmount: 1,
      maxTokens: 30000,
    };
  },
  methods: {
    mintClicked() {
      this.$emit("mintClicked", this.choosedMintingAmount);
    },
    mintAndStakeClicked() {
      this.$emit("mintAndStakeClicked", this.choosedMintingAmount);
    },
  },
};
</script>

<style scoped>
.minting-side {
  background-image: url("../assets/images/minting-parsomen-empty.webp");
  background-repeat: no-repeat;
  background-size: 904px 690px;
  width: 904px;
  height: 690px;
  margin: 10px auto;
}
.minting-header {
  font-size: 100px;
  color: black;
  margin-bottom: -20px;
}
.minted-information {
  color: #151515;
  font-size: 36px;
}
.paused-mint-text {
  position: absolute;
  color: white;
  z-index: 3;
  text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
  font-size: 25px;
  top: 50%;
  transform: translateY(-50%);
}
.minus-button {
  margin: 0 20px 0;
  color: black;
  background: none;
  border: none;
  font-size: 30px;
}
.minus-button img,
.plus-button img {
  width: 84px;
  height: 86px;
}
.button-seperator {
  font-size: 72px;
  display: inline-block;
  text-align: center;
  width: 50px;
  color: black;
}
.mint-button-accelerator {
  margin: 30px 0;
}
.plus-button {
  margin-left: 20px;
  color: black;
  background: none;
  border: none;
  font-size: 30px;
}
.mint-price {
  color: #000000;
  font-size: 48px;
}
.mint-button-image {
  width: 307.5px;
  height: 80px;
}
.mint-button-text {
  color: #907242;
  position: absolute;
  font-size: 40px;
  height: 80px;
  line-height: 70px;
  width: 307.5px;
  text-align: center;
  width: 100%;
}
.mint-button-text:hover {
  text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287,
    1px 1px 20px #ead287;
}
.mint-button {
  background: none;
  border: none;
}
@media (max-width: 700px) {
  .minting-side {
    background-size: 320px 267.3px;
    width: 320px;
    height: 267.3px;
  }
  .minting-header {
    font-size: 40px;
    color: black;
  }
  .minted-information {
    margin-top: 20px;
    color: #151515;
    font-size: 15px;
  }
  .paused-mint-text {
    position: absolute;
    color: white;
    z-index: 3;
    text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
    font-size: 25px;
    top: 50%;
    transform: translateY(-50%);
  }
  .minus-button {
    margin: 0 20px 0;
    color: black;
    background: none;
    border: none;
    font-size: 30px;
  }
  .minus-button img,
  .plus-button img {
    width: 45px;
    height: 45px;
  }
  .button-seperator {
    font-size: 30px;
    display: inline-block;
    text-align: center;
    width: 20px;
    color: black;
  }
  .mint-button-accelerator {
    margin: 0;
  }
  .plus-button {
    margin-left: 20px;
    color: black;
    background: none;
    border: none;
    font-size: 30px;
  }
  .mint-price {
    color: #000000;
    font-size: 20px;
  }
  .mint-button-image {
    width: 140px;
    height: 35px;
  }
  .mint-button-text {
    color: #907242;
    position: absolute;
    font-size: 17px;
    height: 35px;
    line-height: 30px;
    width: 140px;
    text-align: center;
    width: 100%;
  }
  .mint-button-text:hover {
    text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287,
      1px 1px 20px #ead287, 1px 1px 20px #ead287;
  }
  .mint-button {
    background: none;
    border: none;
  }
  @supports (-webkit-touch-callout: none) {
    .plus-button {
      margin: 10px 0 0 -10px;
      color: black;
      background: none;
      border: none;
      font-size: 30px;
    }
    .minus-button {
      margin: 10px -10px 0 0;
      color: black;
      background: none;
      border: none;
      font-size: 30px;
    }
    .mint-button:first-child {
      margin-right: -10px;
    }
    .mint-button:last-child {
      margin-left: -10px;
    }
  }
}
</style>